import TableOptionsFilter from '../components/table/TableOptionsFilter';

export default {
  /* eslint-disable no-underscore-dangle */
  components: {
    TableOptionsFilter,
  },
  data() {
    return {
      tableFilter: '',
      tablePerPage: 10,
      currentPage: 1,
      totalRows: 0,
      windowWidth: 0,
    };
  },
  methods: {
    onPerPageChanged(value) {
      this.tablePerPage = value;
    },
    onFilterChanged(value) {
      this.tableFilter = value;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    /* Adds html css class(es) to the expiration column data based on when a group expires. */
    expirationClass(value, key, item) {
      if (item._expiresSoon) {
        return ['font-weight-bold', 'warning-text', 'groups-expiration-col'];
      }
      return 'groups-expiration-col';
    },
  },
};



// WEBPACK FOOTER //
// ./src/util/table-mixin.js